"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSvg = styled_components_1.default.svg `
    margin: auto;
    color: ${({ theme }) => theme.colorControlIcon};
`;
const NextIcon = () => (react_1.default.createElement(StyledSvg, { viewBox: "0 0 11 7", width: "11px", height: "7px" },
    react_1.default.createElement("polygon", { fill: "currentColor", points: "7 7 11 3.5 7 0 7 3 0 3 0 4 7 4 7 7" })));
exports.NextIcon = NextIcon;
//# sourceMappingURL=NextIcon.js.map